import styled from '@emotion/styled';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { withConfig } from 'src/withConfig';

export const Header = styled('div', { label: 'Header' })`
    padding-top: 16px;
    text-align: center;
    margin-bottom: 24px;
`;

export const Heading = withConfig(theme => styled('h4', { label: 'Heading' })`
    font-size: ${theme.star.fontSize.xMedium};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.4;
    margin: 0;
`);
export const ReviewAccountsButton = withConfig(theme => styled(Button, { label: 'ReviewAccountsButton' })`
    color: ${theme.star.utilityPage.txtColorQuinary};
`);

export const ReviewLimitsButton = withConfig(theme => styled(Button, { label: 'ReviewLimitsButton' })`
    background-color: ${theme.star.utilityPage.bgColorTertiary};
    color: ${theme.star.utilityPage.txtColorQuaternary};
`);

export const RemindLater = withConfig(theme => styled('div', { label: 'RemindLater' })`
    font-weight: ${theme.star.fontWeight.bold};
    cursor: pointer;
    text-align: center;
    font-size: ${theme.star.fontSize.small};
`);

export const Text = withConfig(theme => styled('p', { label: 'Text' })<{isBold?: boolean}>`
    font-size: ${theme.star.fontSize.small};
    font-weight: ${({ isBold }): string => isBold === true ? theme.star.fontWeight.bold : theme.star.fontWeight.regular};
    line-height: 1.3333;
    margin-top: 4px;
`);

export const Container = styled.div`
    padding: 0 1px 1px;
`;

export const ButtonsGroup = styled('div', { label: 'ButtonsGroup' })`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
